var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{staticClass:"mb-2 mr-4",on:{"click":function($event){return _vm.getBookLists()}}},[_vm._v("Export ป.17")])
}
var staticRenderFns = []

export { render, staticRenderFns }